import { Queries } from 'gql';
import { createProjectProvider } from 'providers/createProjectProvider';

const { ProjectProvider, useCurrentProject, withProjectProvider } = createProjectProvider({
  getPhaseQuery: Queries.GET_PHASE,
});

export { useCurrentProject, withProjectProvider };

export default ProjectProvider;
